var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireworkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 348.53 346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffe564;\n      }\n\n      .cls-2 {\n        fill: #ff4d78;\n      }\n\n      .cls-3 {\n        fill: #7bc7ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m253.02,324.64s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77s2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.57,312.07s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.82,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m311.75,86.29s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77,1.82,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3.73,183.81s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77,1.89,2.5,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m303.64,246.72s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m165.31,31.28s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.82,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m338.24,162.25s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77,1.82,2.43,2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.64,29.53s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.89,2.37,2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m312.22,260.71s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m263.77,54.67s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.41.95,1.35,2.77-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.82,297.27s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.27.95,1.28,2.77-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.35,295.11s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.41.95,1.42,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m292.76,83.45s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34.95,1.28,2.77-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m65.97,248.01s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34.95,1.42,2.77-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m38.53,69.6s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34,1.01,1.42,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m151.12,23.31s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.41,1.01,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.45,187.05s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m55.02,73.45s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34.95,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m78.88,52.5s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34.95,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.76,61.63s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.89,2.3,2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m330.67,215.57s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.82,2.3,2.3,6.15-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m248.56,71.49s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77,1.82,2.23,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m21.23,129.61s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.82,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.06,140.29s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77,1.82,2.43,2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.4,165.09s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.76,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m273.63,165.09s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.76,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m252.14,286.86s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.89,2.3,2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.5,240.17s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.82,2.37,2.43,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.42,303.49s-3.45-.27-3.72-3.31c-.27-3.04,4.26-5.27,6.15-2.77,1.89,2.5,2.3,6.15-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m157.33,339.64s-3.45-.27-3.72-3.31,4.26-5.27,6.15-2.77c1.89,2.37,2.37,6.22-2.43,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.14,195.7s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.27,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m249.98,60.07s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m101.18,48.85s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34,1.01,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m27.99,139.41s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34.95,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.07,48.85s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34,1.01,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30.15,118.53s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34.88,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.43,155.9s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34.88,1.35,2.77-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m278.84,146.17s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.27.95,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.43,170.97s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.41,1.01,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m283.3,155.63s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34.95,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m233.83,276.59s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.27.95,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m70.63,299.37s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m153.35,328.9s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.73,273.75s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.27.95,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.45,290.99s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m173.48,328.9s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34,1.01,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.76,229.08s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34.95,1.35,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.79,243.21s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34,1.01,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m340.6,118.53s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.34.95,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m320.47,128.12s-3.51-1.08-2.43-3.11c1.08-2.03,3.38-.95,3.65,0,.27.95,1.28,2.84-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m318.24,211.99s-3.51-1.08-2.43-3.11,3.38-.95,3.65,0c.34.88,1.35,2.77-1.22,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m339.19,204.15s-4.39.81-3.72-3.04c.68-3.85,5.54-1.89,5.81,0,.2,1.89-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m238.9,57.91s-4.39.81-3.72-3.04c.68-3.85,5.54-1.89,5.81,0,.2,1.89-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.37,286.32s-4.39.81-3.72-3.04,5.54-1.89,5.81,0c.14,1.89-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.53,306.12s-4.39.81-3.72-3.04c.68-3.85,5.54-1.89,5.81,0,.14,1.82-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m171.59,337.28s-4.39.81-3.72-3.04,5.54-1.89,5.81,0-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.49,248.48s-4.39.81-3.72-3.04,5.54-1.89,5.81,0c.2,1.76-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m329.86,108.32s-4.39.81-3.72-3.04c.68-3.85,5.54-1.89,5.81,0,.14,1.82-2.09,3.04-2.09,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m333.58,128.6s-4.39.81-3.72-3.04c.68-3.85,5.54-1.89,5.81,0,.14,1.89-2.09,3.04-2.09,3.04Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.1,157.86s-65.55,49.6-79.74,75.08c0,0-11.89.88,0-12.5,12.03-13.45,35.28-38.79,79.74-62.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.32,138.73s-53.59-40.07-79-47.51c-1.82-.54-2.91-2.43-2.3-4.19.68-1.76,3.11-2.91,10.54.68,13.92,6.62,40.48,19.87,70.75,51.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m186.59,138.73s57.04-35.01,83.05-40.01c1.82-.34,3.18-2.16,2.7-3.92-.47-1.82-2.77-3.18-10.61-.34-14.46,5.34-42.1,16.08-75.15,44.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.31,165.83s-44.2,78.39-45.21,104.75c0,0-7.03,10.41-7.5-2.97-.47-13.45,17.44-55.62,52.71-101.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.13,134.14s-84.4-10.68-111.84-2.97c-1.96.54-4.12.34-6.01-.68-2.23-1.28-3.45-3.45,3.65-6.69,12.3-5.47,58.12-4.87,114.21,10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.7,165.16s-75.75,48.59-89,71.43c0,0-11.08,5.95-5.27-6.15,5.88-12.16,41.49-41.02,94.27-65.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m218.76,155.42s84.95,29.87,102.99,49.06c0,0,12.16,3.18,3.65-7.16-8.45-10.41-49.67-30.41-106.64-41.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.09,136.71s-17.5-72.85-32.3-92.99c-.95-1.28-1.49-2.91-1.35-4.53.2-2.5,1.49-4.93,6.76.41,8.24,8.24,22.03,46.16,26.9,97.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m174.16,194.15s-26.76,145.43-10.14,136.85c0,0,2.91,3.04,4.05-26.22,1.22-29.33.07-64.06,6.08-110.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.13,201.58s27.3,154.75,9.46,143.87c0,0-3.31.14-1.69-16.29,1.62-16.42-5.81-122.18-7.77-127.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.79,186.24s-97.72,112.25-76.9,110.96c0,0,2.91,1.62,9.06-13.58,6.08-15.27,57.71-84.61,67.85-97.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m222.01,187.05s98.73,122.18,77.85,121.37c0,0-2.91,1.69-9.33-13.38-6.35-15.14-64.2-104.14-68.52-107.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m196.06,165.83s65.55,108.6,49.33,110.96c-8.79,1.22-6.28-30.61-49.33-110.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.99,157.86s107.79,69.74,83.39,75.08c0,0-4.6-3.11-18.38-20.48-16.42-20.75-65.01-54.6-65.01-54.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m214.5,133.39s109.68-34.53,111.77-19.39c.2,1.69-1.08,3.18-2.77,3.38-3.11.41-10.41,1.01-25.48.74-26.42-.54-83.53,15.27-83.53,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.6,147.25s-81.43-2.16-80.28,16.02c0,0,1.42,2.57,15.21-5.2,15.54-8.72,65.08-10.81,65.08-10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m183.35,125.96s18.52-99.54,32.37-83.8c0,0,3.11,2.3-7.64,15.68-12.37,15.27-24.73,68.12-24.73,68.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.78,116.36s-55.41-76.9-60.96-58.05c0,0-1.69,3.18,12.7,10.2,16.62,7.97,48.25,47.85,48.25,47.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.38,131.23s45.55-81.23,53.05-63.46c0,0,2.03,2.91-11.29,11.35-15.27,9.66-41.76,52.1-41.76,52.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.03,147.86s80.08-11.08,82.17,4.39c0,0-2.09,3.92-20.41-1.15-25.54-7.16-61.77-3.24-61.77-3.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m278.64,192.66s50.95,34.26,61.23,69.67c.34,1.08.27,2.23-.2,3.31-.61,1.35-1.89,2.43-4.32-1.01-3.85-5.34-23.52-47.24-56.7-71.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m179.9,93.52s-5.74-61.16,15.41-91.5c.61-.95,1.55-1.62,2.64-1.89,1.49-.41,3.11-.07,1.96,3.99-1.69,6.42-21.69,48.12-20,89.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m214.5,105.69s44.4-42.51,81.23-44.87c1.15-.07,2.23.2,3.18.88,1.22.88,1.96,2.37-1.89,4.05-6.15,2.64-51.22,12.91-82.51,39.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m252.14,241.92s28.72,54.27,20.95,90.42c-.27,1.08-.81,2.09-1.69,2.77-1.22.95-2.84,1.22-3.38-2.91-.88-6.56,1.62-52.78-15.88-90.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m133,119.41s-57.64-25.41-109.81-20.48c0,0-10.14,1.55-6.15,3.04,9.53,3.45,23.25-3.92,59,2.97,34.67,6.69,56.97,14.46,56.97,14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.33,165.16S10.82,183.67.82,204.69c0,0-1.96,6.62,4.53-.2,6.49-6.76,26.29-24.13,62.98-39.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m69.62,212.87s-39.06,35.14-39.47,55.35c0,0,.81,5.95,3.51-1.76,2.77-7.7,12.23-28.52,35.95-53.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m287.08,162.11s51.02,12.3,61.09,29.94c0,0,2.09,5.61-3.92.14-6.15-5.41-24.4-19.19-57.17-30.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m75.77,87.58s-50.28-15.14-67.78-5.07c0,0-4.73,3.72,3.31,2.09,7.97-1.55,30.75-4.19,64.47,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m282.69,103.39s38.18-15.34,52.51-8.65c0,0,3.85,2.57-2.43,1.89-6.35-.74-24.26-1.22-50.08,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m125.23,278.89s-15.95,42.24-8.31,57.78c0,0,2.91,4.19,2.03-2.7-.95-6.96-1.89-26.56,6.28-55.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m275.26,233.95s33.59,30.07,34.06,47.44c0,0-.68,5.14-3.04-1.49-2.43-6.62-10.61-24.46-31.02-45.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.64,138.06s80.35-16.35,106.1,1.89c0,0,6.76,6.56-5.54,2.77-12.1-3.65-46.97-11.08-100.56-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m209.1,232.4s29.46,76.5,15.81,104.95c0,0-5.34,7.7-3.65-5,1.49-12.64,2.97-48.25-12.16-99.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.83,67.84s35.21-49.13,58.25-52.24c0,0,6.89.14-1.55,4.26-8.45,4.19-30.95,17.64-56.7,47.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.9,85.82s-50.14-33.72-72.92-28.52c0,0-6.42,2.5,2.91,3.45,9.33,1.01,35.28,5.68,70.01,25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m109.83,241.92s-47.17,69.06-35.61,81.57c4.6,5-.95-4.8,15.54-40.21,15.75-33.99,20.07-41.36,20.07-41.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m117.19,140.35s-103.8,3.72-110.15,21.49c-2.5,7.16,4.53-3.78,53.12-12.3,46.43-8.11,57.04-9.19,57.04-9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m155.31,219.42s-33.79,80.35-12.91,86.7c0,0,3.78-1.01,1.15-8.99-2.64-7.91-3.31-30.82,11.76-77.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m161.32,95.62S125.64,16.08,106.72,27.03c0,0-1.82,3.45,5.81,7.03,7.64,3.45,24.73,18.58,48.79,61.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireworkBlue);
export default __webpack_public_path__ + "static/media/firework-blue.60832f895dd627e5c0489a32d0a6f0fa.svg";
export { ForwardRef as ReactComponent };